import './Modal.scss';

export default function ModalTitle({ children }: any) {
  return (
    <div className="modal-title">
      <h1>{children}</h1>
    </div>
  );
}
